import { render, staticRenderFns } from "./DishOption.vue?vue&type=template&id=d4c26146&"
import script from "./DishOption.vue?vue&type=script&lang=js&"
export * from "./DishOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports